import { countryListQueryOptions } from '@/hooks/settings/use-country-list';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export async function authLayoutLoader() {
  return {
    countryListPromise: queryClient.prefetchQuery(countryListQueryOptions).catch(catchFetcherError),
  };
}
